import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonDirective } from './button.directive';
import { SpinnerModule } from '../spinner/spinner.module';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonDirective, ButtonComponent],
  imports: [CommonModule, SpinnerModule],
  exports: [ButtonDirective, ButtonComponent],
})
export class ButtonModule {}
